// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__gsJBl","buttons":"styles_buttons___8id7","pulse":"styles_pulse__3LFUS","jump":"styles_jump__VVRne","wiggle":"styles_wiggle__pLfn_"};